import { toast } from "react-toastify";
import React from "react";
import "./index.css";

export enum ToastType {
  Success = 0,
  Error = 1
}

const notify = (type: ToastType, message: string | React.ReactNode) => {
  switch (type) {
    case ToastType.Success:
      return toast.success(message, {
        autoClose: 2500,
      });
    case ToastType.Error:
      return toast.error(message, {});
    default:
      break;
  }
};

export default notify;
